import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'cosmos-cluster-add-collaborator',
  templateUrl: './cluster-add-collaborator.component.html',
  styleUrls: ['./cluster-add-collaborator.component.scss'],
})
export class ClusterAddCollaboratorComponent {
  public readonly _collaboratorForm: FormGroup;

  public constructor(
    private readonly _modalRef: MatDialogRef<ClusterAddCollaboratorComponent>,
    private readonly _formBuilder: FormBuilder,
  ) {
    this._collaboratorForm = this._formBuilder.group({
      userId: [null, Validators.required],
    });
  }

  public closeModal(result?: string): void {
    this._modalRef.close(result);
  }
}
